export default {
  // root: {},
  // input: {
  //   underline: {
  //     border: 0,
  //   },
  //   backgroundColor: "red",
  // },
};
